module.exports = __webpack_public_path__ + "img/BluScore.8f09924b.svg";